import { IconButton, Stack, Typography, type SxProps } from '@mui/material';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useRef } from 'react';
import { ExistingStockItem } from '@features/stock/entity';
import { formatToCZK } from '@shared/entity';
import { StockItemFormDialog } from '@features/stock/components/stock-item-form-dialog';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import BoxIcon from '@shared/components/BoxIcon';
import { useFormatCurrency } from '@features/currency/currency.hooks';

type GoodsSearchResultItemProps = {
  item: ExistingStockItem;
  sx?: SxProps;
};

const GoodsSearchResultItem = ({ item, sx }: GoodsSearchResultItemProps) => {
  const editRef = useRef<ImperativeFormDialogRefType>(null);
  const { format: fmtCurrency } = useFormatCurrency();

  return (
    <>
      <Stack
        marginY="5px"
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        spacing={1}
        sx={{ color: 'inherit', ...sx }}
      >
        <IconButton>
          <ShoppingBagOutlinedIcon fontSize="large" />
        </IconButton>
        <Stack justifyContent="center" height="100%" flex={1}>
          <Typography fontWeight={600} color="text.primary" fontSize="1rem">
            {item.itemName}
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
            {item.brand && (
              <>
                <Typography variant="caption" color="text.secondary">
                  {item.brand}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  ·
                </Typography>
              </>
            )}
            <Typography variant="caption" color="text.secondary">
              Sklad: {item.packageCount} ks
            </Typography>
            {item.retailPrice != null && item.retailPrice > 0 && (
              <>
                <Typography variant="caption" color="text.secondary">
                  ·
                </Typography>
                <Typography variant="caption" color="#ff6221">
                  {fmtCurrency(item.retailPrice, undefined, 0, 0)}/ks
                </Typography>
              </>
            )}
          </Stack>
        </Stack>
        <BoxIcon
          onClick={() => editRef.current?.open()}
          boxColor="secondary.light"
          size="small"
          icon={<EditOutlinedIcon fontSize="small" color="secondary" />}
        />
      </Stack>
      <StockItemFormDialog
        dialogRef={editRef}
        formUsagePurpose="stockItem"
        defaultValues={{
          id: item.id,
          itemName: item.itemName,
          stockId: item.stockId,
          totalPrice: Math.round(item.totalPrice),
          quantity: Math.round(item.quantity / item.packageCount),
          lastPackageQuantity: item.lastPackageQuantity,
          avgUnitPrice: item.avgUnitPrice,
          threshold: item.threshold,
          unit: item.unit,
          packageCount: item.packageCount,
          itemType: item.itemType,
          retailPrice: item.retailPrice,
          brand: item.brand,
        }}
      />
    </>
  );
};

export default GoodsSearchResultItem;
